var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "search-widget" } }, [
    _c(
      "div",
      {
        staticClass: "ui fluid icon inverted input",
        attrs: { id: "search-term-box" }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.terms,
              expression: "terms"
            }
          ],
          attrs: {
            tabindex: "1",
            type: "text",
            placeholder: "Search by project name, topic..."
          },
          domProps: { value: _vm.terms },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.clearSearchBox.apply(null, arguments)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.terms = $event.target.value
            }
          }
        }),
        !_vm.terms ? _c("i", { staticClass: "search icon" }) : _vm._e(),
        _vm.terms
          ? _c("i", {
              staticClass: "remove link icon",
              on: { click: _vm.clearSearchBox }
            })
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7131071a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7131071a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CitywideSearchWidget.vue
// module id = null
// module chunks = 